export default {
    text: 'text',
    date: 'date',
    number: 'number',
    boolean: 'boolean',
    entity: 'entity',
    select: 'select',
};
